// Header.jsx - Updated
import { useTheme } from "../../context/ThemeContext";
import { useState, useContext } from "react";
import { AuthContext } from "../../context/AuthContext";
import { Link } from "react-router-dom"; // Add this import

const Header = ({ toggleSidebar }) => {
  const { theme, toggleTheme } = useTheme();
  const { user, logout } = useContext(AuthContext);
  const [profileOpen, setProfileOpen] = useState(false);

  const handleProfileClick = (e) => {
    e.preventDefault();
    setProfileOpen(!profileOpen);
  };

  const handleLogout = () => {
    logout();
    window.location.href = "/";
  };

  return (
    <header className="app-header">
      <div className="header-left">
        <button className="menu-toggle" onClick={toggleSidebar}>
          <i className="bx bx-menu"></i>
        </button>
      </div>

      <div className="header-right">
        {/* Theme Toggle */}
        <button className="header-icon theme-toggle" onClick={toggleTheme}>
          <i className={`bx ${theme === "dark" ? "bx-sun" : "bx-moon"}`}></i>
        </button>

        {/* Profile */}
        <div className="profile-wrapper">
          <button
            className="profile-btn"
            onClick={handleProfileClick}
          >
            {/* {user?.avatar ? (
              <img
                src={user.avatar}
                alt={user?.name || "User"}
                className="profile-img"
              />
            ) : (
              <div className="profile-img-initials">
                {user?.name 
                  ? user.name.split(' ').map(n => n[0]).join('').toUpperCase().substring(0, 2)
                  : 'U'
                }
              </div>
            )} */}
            {user && (
              <div className="profile-info">
                <p className="profile-name">{user?.name || "User"}</p>
                <span className="profile-role">{user?.role || "Member"}</span>
              </div>
            )}
            <i className={`bx bx-chevron-down profile-arrow ${profileOpen ? 'open' : ''}`}></i>
          </button>

          {profileOpen && (
            <div className="profile-dropdown">
              {/* Use Link component for React Router navigation */}
              <Link to="/profile" className="dropdown-item" onClick={() => setProfileOpen(false)}>
                <i className="bx bx-user"></i>Profile
              </Link>
              <Link to="/settings" className="dropdown-item" onClick={() => setProfileOpen(false)}>
                <i className="bx bx-cog"></i>Settings
              </Link>
              <button
                className="dropdown-item logout-btn"
                onClick={handleLogout}
              >
                <i className="bx bx-log-out"></i>Logout
              </button>
            </div>
          )}
        </div>
      </div>
    </header>
  );
};

export default Header;